export default "__VITE_ASSET__af7133ad__"